<template>
  <FormInputWrapper :error="error" :label="label" :lang="lang" :required="required">
    <TextInput :is-error="isError" v-bind="$attrs" />
  </FormInputWrapper>
</template>

<script setup lang="ts">
import type { Lang } from '@/models/lang';
import { FormInputWrapper, TextInput } from '@/wabunka-src/common/components';

interface Props {
  label: string;
  required?: boolean;
  error?: string;
  lang?: Lang;
}

const props = withDefaults(defineProps<Props>(), {
  required: true,
  error: '',
  lang: 'jp',
});

const isError = computed(() => !!props.error && props.error !== '');
</script>
